<header class="header" [class.scrolled]="isScrolled">
  <div class="container">
    <div class="header-content">
      <div class="logo">
        <h1>IGLOOCODE</h1>
      </div>

      <nav class="nav-menu" [class.active]="menuOpen">
        <ul class="nav-list">
          <li><a href="#inicio">Início</a></li>
          <li><a href="/sobre-nos" (click)="scrollToTop($event)">Sobre nós</a></li>
          <li><a routerLink="/servicos">Serviços</a></li>
          <!-- <li><a href="#parceiros">Clientes</a></li> -->
          <!-- <li><a href="#contato" (click)="scrollToContato($event)">Contato</a></li> -->
        </ul>
      </nav>

      <div class="header-actions">
        <a href="https://wa.me/5548988527818?text=Olá!%20Gostaria%20de%20realizar%20um%20orçamento%20para%20a%20criação%20de%20uma%20página%20web" target="_blank" rel="noopener" class="btn-area-virtual">Entre em contato</a>
          <button class="menu-toggle" (click)="toggleMenu()">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </div>
</header>
